import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Grid } from "@mui/material";

import { DB, Constant } from "../../constants";
import { CustomizedPdfDialog, CustomizedConfirmDialog } from "../../components";
import { ApiService } from "../../services";
import NavigationBar from "../NavigationBar"
import "./style.css"
import { useTranslation } from 'react-i18next';

const SubmittedFormHistoryPage = () => {
    const { t: translate } = useTranslation();
    const { state } = useLocation()
    const [submittedForm, setSubmittedForm] = useState([])
    const [open, setOpen] = useState(false)
    const [selectId, setSelectId] = useState("")
    const [pdfUrl, setPdfUrl] = useState("")
    const userId = localStorage.getItem(Constant.localStorageKey.userId);

    const getSubmitForm = async () => {
        const submitFormDataQuery = await DB.submitFormData.toArray();
        const submitFormDatasByUserId = submitFormDataQuery.filter((form) => form.userId === parseInt(userId));

        let historyLength = submitFormDatasByUserId.length
        const filter = []
        const total = submitFormDatasByUserId.length
        for (let i = 0; i < historyLength; i++) {
            filter.push(submitFormDatasByUserId[total - 1 - i])
        }
        setSubmittedForm(filter)
    }

    const openPdf = (id, url) => {
        setSelectId(id)
        setPdfUrl(url)
        setOpen(true)
    }

    useEffect(() => {
        getSubmitForm()
    }, [])

    return <div className={`page ${state && state.prev ? "page--prev" : ""}`}>
        <NavigationBar showToolBar={false} showNavBar={true} />
        <div className="form-group">
            <h1>{translate('synchronizedReports')}</h1>
            {submittedForm.length > 0 ?
                <Grid container spacing={2}>
                    {submittedForm.map((id) => {
                        return <Grid item key={id.data} xs={12} md={4} xl={2}>
                            <div key={id.data} className="history-list-item" onClick={() => openPdf(id.data, id.pdfUrl)}>{id.data}</div>
                        </Grid>
                    })}
                </Grid>
                : <Grid item xs={12} md={12} xl={12}>
                    <p className="empty-list-text">{translate('noReportSynchronized')}</p>
                </Grid>}
        </div>
        <CustomizedPdfDialog open={open} id={selectId} pdfUrl={pdfUrl} handleClose={() => setOpen(false)} />
    </div>
}

export default SubmittedFormHistoryPage;